import { render, staticRenderFns } from "./DashboardVideofiles.vue?vue&type=template&id=7ce87ed7"
import script from "./DashboardVideofiles.vue?vue&type=script&lang=js"
export * from "./DashboardVideofiles.vue?vue&type=script&lang=js"
import style0 from "./DashboardVideofiles.vue?vue&type=style&index=0&id=7ce87ed7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports